/*----- Imports -----*/
import React  from 'react'
import styled from 'styled-components'
import { css } from 'styled-components'

/*----- Assets -----*/
import SuccessIcon from '../../assets/icons/success.svg'
import ErrorIcon  from '../../assets/icons/error.svg'

/*----- Ant design -----*/
import { notification } from 'antd'
import Montserrat from '../../commons/mixins/fonts/Montserrat'

const getImage = (type) => {
	switch (type) {
		case 'success':
			return SuccessIcon
		case 'error':
			return ErrorIcon
		default:
			return 
	}
}

/*----- Styles -----*/
const StyledNotification = styled.div `
	.notification__message-container {
		display: flex;
	}
	.notification__message {
		${ Montserrat(16, 600,'black') };
		line-height: 16px;
		margin-top: 16px;
		${props => props.type && css`
			color: ${ props.type === 'success'? '#00c8ac': '#ff6161' } !important;
		`}
	}
	.notification__image {
		width: 26px;
		margin-right: 20px;
	} 
`

const Notification = ({ message, type }) => (
	<StyledNotification className="notification" type={type}>
		<div className="notification__message-container">
			<img src={getImage(type)} alt="notification icon" className="notification__image"/>
			<p className="notification__message">{ message}</p>
		</div>
	</StyledNotification>
)

/*----- Export -----*/
export default function openNotification(message, type) {
	return notification.open({
	  	description: <Notification message={message} type={type} />,
	  	duration: 10
	})
}